import { OutgoingRowLayoutTier } from "types/outgoing";

/*
 * Desktop Outgoing rows are flex rows that always fill the list width:
 * spare width is spread across the cells proportionally to their flex-grow
 * ratios (carrier 3x, dimensions 1.5x, other data cells 1x, sku anchored),
 * with the px constants below as flex-bases the cells never shrink under.
 * When the list narrows (right-panel squeeze, small viewport) the layout
 * tier drops trailing cells instead of letting text wrap. Shared here
 * because five row components (NotFinished, InProgress,
 * WaitingForInformation, WaitingForPayment, Paid) use the same cells and
 * tier thresholds.
 */

// Minimum desktop cell widths (flex-basis px, incl. the 10px side paddings),
// sized to the longest localized content so cells never wrap.
export const SKU_COL_WIDTH = 120; // "PK1027442" + excess marker
export const WEIGHT_COL_WIDTH = 110; // "27.8 кг" / "27.8 lbs"
export const WEIGHT_BRUTTO_COL_WIDTH = 150; // "4.4 кг (брутто)" / "27.8 кг/$ 19.00"
export const DIMENSIONS_COL_WIDTH = 190; // "61.0 x 48.3 x 50.8 см" / "Четыре коробки"
export const PRICE_COL_WIDTH = 110; // "$ 1092.00"
export const STATE_COL_WIDTH = 180; // dot + "В процессе упаковки"

// List widths (px) below which sections drop trailing cells (dimensions
// first, then weight; sku/carrier/price/state/buttons never drop). The
// right-panel squeeze narrows the list without resizing the viewport, so
// tiers come from the measured list width (useContainerQuery), not media
// queries. Keep both thresholds well under ~910px — the 1280×900 e2e
// viewport with the panel closed must stay on the "full" tier.
export const DIMENSIONS_MIN_WIDTH = 700;
export const WEIGHT_MIN_WIDTH = 540;

export const getOutgoingLayoutTier = (
  listWidth: number,
): OutgoingRowLayoutTier => {
  if (listWidth < WEIGHT_MIN_WIDTH) return "narrow";
  if (listWidth < DIMENSIONS_MIN_WIDTH) return "medium";
  return "full";
};
